import { render, staticRenderFns } from "./SafetySettingsForm.vue?vue&type=template&id=e2439e10"
import script from "./SafetySettingsForm.vue?vue&type=script&lang=js"
export * from "./SafetySettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports